<div class="error-bar" [ngClass]="{ show: !!errorBarService.errorMessage() }">
  @if (errorBarService.errorMessage(); as message) {
    <div role="alert">
      {{ message || '' }}
    </div>
  }
</div>
